/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { AlertsListDto, AlertDto } from '../api/alerts/alertsClient.typings';
import { AlertsState } from '../reducers/alertsReducer';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import { PageParams } from '../api/apiCommon.typings';

export enum AlertsActionType {
    OPEN_ALERTS_PAGE = 'Alerts/ open page',
    EXIT_ALERTS_PAGE = 'Alerts/ exit page',

    CHANGE_ALERTS_PAGE = 'Alerts/ change page',
    FETCH_ALERTS_PAGE_SUCCESS = 'Alerts/ fetch success',
    FETCH_ALERTS_PAGE_ERROR = 'Alerts/ fetch error',

    FETCH_NEW_ALERTS_SUCCESS = 'Alerts/ fetch new success',
    SET_BASE_TIME_TO_POLL_NEW_ALERTS = 'Alerts/ set base id to poll new alerts',

    CHANGE_SORT = 'Alerts/ change sort',
    CHANGE_FILTERS = 'Alerts/ change filters',

    SHOW_NEW_ALERTS = 'Alerts/ show new',

    SELECT_ALERTS = 'Alerts/ select alerts',
    UPDATE_ALERTS = 'Alerts/ alerts update',
    UPDATE_ALERTS_SUCCESS = 'Alerts/ alerts update success',
}

export const changeAlertsPageAction = (page: PageParams) => createAction(AlertsActionType.CHANGE_ALERTS_PAGE, page);

export const fetchAlertsPageSuccessAction = (list: AlertsListDto) =>
    createAction(AlertsActionType.FETCH_ALERTS_PAGE_SUCCESS, {
        list,
        notification:
            list.count === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const changeFiltersAction = (params: AlertsState['filterParams']) =>
    createAction(AlertsActionType.CHANGE_FILTERS, params);

export const changeSortAction = (params: AlertsState['sort']) => createAction(AlertsActionType.CHANGE_SORT, params);

export const selectAlertsAction = (alerts: AlertDto[]) => createAction(AlertsActionType.SELECT_ALERTS, alerts);

export const setBaseDateToPollNewAlerts = ({ alertId, dateFrom }: { alertId: AlertDto['id']; dateFrom?: number }) =>
    createAction(AlertsActionType.SET_BASE_TIME_TO_POLL_NEW_ALERTS, { alertId, dateFrom });

export const openAlertsPageAction = () => createAction(AlertsActionType.OPEN_ALERTS_PAGE);

export const exitAlertsPageAction = () => createAction(AlertsActionType.EXIT_ALERTS_PAGE);

export const fetchNewAlertsSuccessAction = (newAlerts: AlertsListDto) =>
    createAction(AlertsActionType.FETCH_NEW_ALERTS_SUCCESS, newAlerts);

export const showNewAlerts = () => createAction(AlertsActionType.SHOW_NEW_ALERTS);

export const updateAlertsAction = (alerts: AlertDto[]) => createAction(AlertsActionType.UPDATE_ALERTS, alerts);

export const updateAlertsSuccess = (updatedAlerts: AlertDto[]) =>
    createAction(AlertsActionType.UPDATE_ALERTS_SUCCESS, updatedAlerts);

export const alertsErrorAction = (notification: Notification) =>
    createAction(AlertsActionType.FETCH_ALERTS_PAGE_ERROR, { notification });

export type AlertsAction =
    | ReturnType<typeof changeAlertsPageAction>
    | ReturnType<typeof fetchAlertsPageSuccessAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof changeSortAction>
    | ReturnType<typeof openAlertsPageAction>
    | ReturnType<typeof exitAlertsPageAction>
    | ReturnType<typeof setBaseDateToPollNewAlerts>
    | ReturnType<typeof fetchNewAlertsSuccessAction>
    | ReturnType<typeof showNewAlerts>
    | ReturnType<typeof selectAlertsAction>
    | ReturnType<typeof alertsErrorAction>
    | ReturnType<typeof updateAlertsAction>
    | ReturnType<typeof updateAlertsSuccess>;
